var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"on":_vm.on,"click":_vm.onClick,"cancel":_vm.onCancel,"confirm":_vm.confirm})],2)}
var staticRenderFns = []

export { render, staticRenderFns }